import { Modal } from 'bootstrap';
import moment from 'moment';
import { SCCombinedEvent } from 'static/classes/Event';
import { SCAdminTodo } from 'static/classes/Todo';

export function TodoViewModel(data){
    var self = this;
    self.type = "TodoViewModel";

    self.rootvm = data.rootvm;

    self.sc_event = ko.observable(new SCCombinedEvent({}));

    self.todo = ko.observable(new SCAdminTodo({}));
    self.admin_user_list = ko.observableArray([]);
    self.admin_todo_type_list = ko.observableArray([]);

    self.artist_list = ko.pureComputed(function(){
        return ko.utils.arrayMap(self.sc_event().invites(), function(e){
            return {'artist_name':e.artist().artist_name(),
                    'event_uuid': e.event_uuid()};
        });
    });

    self.save_todo = function(){
        if(self.todo().todo_uuid() !== undefined){
            return self.close_todo();
        }

        self.todo().todo_inviter_person_uuid(self.sc_event().creator_uuid());
        console.log("SAVING TODO: ", self.todo().todo_type());
        const rootvm_save = self.todo().rootvm;
        self.todo().rootvm = undefined;
        const data = {
            todo : self.todo(),
        };

        const options = {
            method: 'POST',
            body: ko.toJSON( data )
        };
        fetch( '/api/admin/todo', options )
            .then( response =>
            {
                if(!response.ok){
                    console.log(response);
                    throw new Error("Something went wrong!");
                }
                else{
                  const contentType = response.headers.get("content-type");
                  if(contentType && contentType.indexOf("application/json") === -1){
                    throw new Error("Response was not JSON");
                  }

                  return response.json()
                }
            }
            )
            .then( response => {
                // Do something with response.
                let todo = response.todo;
                todo.rootvm = self.rootvm;
                todo.assigned_user_pretty = response.assigned_user_pretty;
                self.sc_event().todo_list.push(new SCAdminTodo(todo));
                notyf.success('Todo added.');
                //self.todo().rootvm = rootvm_save;
                self.todo(new SCAdminTodo({rootvm:self.rootvm,
                    assigned_to: self.todo().assigned_to()}));

                self.todo().assigned_user_pretty(response.assigned_user_pretty);

                // keep assigned to the same
                //self.todo().due_date(undefined);
                // Pikaday component needs manual clear
                //$('#editDate')[0].value = '';
                const conAdminTODO = document.getElementById('conAdminTODO');
                Modal.getOrCreateInstance(conAdminTODO).hide();

            } )
            .catch((error) => {
              console.log(error);
                notyf.error("Sorry something went wrong ", error);
            });


        return false;
    };

    self.complete_and_reopen = function(){
        let success = false;
        if(self.todo().close_comment() && self.todo().close_action()){
            success = self.close_todo(false);
        }
        else{
            alert("Please add a closing comment and action")
            return false;
        }
        console.log("CLOSING AND SUCCESS IS ", success);
        // then reset todo
        //
        if(success !== false){
            const current_todo = self.todo();
            self.todo(new SCAdminTodo({rootvm:self.rootvm}));
            //self.todo().todo_uuid(undefined);
            self.todo().due_date(new moment(current_todo.due_date()).add(5, 'days').format('YYYY-MM-DD'));
            self.todo().open_comment("REMINDER : " + current_todo.open_comment() +
            '\n---\n' + new moment().format('DD.MM.YY') + ': ' + current_todo.close_comment());
            self.todo().todo_type(current_todo.todo_type());
            self.todo().assigned_to(current_todo.assigned_to());
            self.todo().todo_event_uuid(current_todo.todo_event_uuid());
        }
        return false;
    }

    self.edit_mode = ko.observable(false);

    self.todo_edit_save = undefined;

    self.edit_mode.subscribe(function(){
        console.log("Self edit mode changed to ", self.edit_mode());
        if(self.edit_mode() == true){
            self.todo_edit_save = {
                assigned_to: self.todo().assigned_to(),
                event_uuid: self.todo().todo_event_uuid(),
                todo_type: self.todo().todo_type(),
                due_date: self.todo().due_date()
            };
        }

    });

    self.cancel_edit = () =>{

        self.todo().assigned_to(self.todo_edit_save.assigned_to);
        self.todo().todo_event_uuid(self.todo_edit_save.todo_event_uuid);
        self.todo().todo_type(self.todo_edit_save.todo_type);
        self.todo().due_date(self.todo_edit_save.due_date);


        self.edit_mode(false);
    }

    self.edit_todo = function() {

        // We can edit an already created todo
        console.log("UPDATING TODO: ", self.todo().todo_type());

        const data = {
            todo_uuid : self.todo().todo_uuid(),
            due_date: self.todo().due_date(),
            event_uuid : self.todo().todo_event_uuid(),
            todo_type : self.todo().todo_type(),
            assigned_to: self.todo().assigned_to()

        };

        const options = {
            method: 'POST',
            body: ko.toJSON( data )
        };

        fetch( '/api/admin/todo/update', options )
            .then( response =>{

                if(!response.ok){
                    console.log(response);
                    throw new Error("Something went wrong!");
                }
                else{
                  const contentType = response.headers.get("content-type");
                  if(contentType && contentType.indexOf("application/json") === -1){
                    throw new Error("Response was not JSON");
                  }
                  return response.json()
                }
            }).then ( response => {

                console.log('Todo saved ', response);
                notyf.success('Todo saved.');
                self.todo().assigned_user_pretty(
                    ko.utils.arrayFirst(self.admin_user_list(), (x)=>{
                        return x.person_uuid == self.todo().assigned_to()
                    }).display_name);

                const conAdminTODO = document.getElementById('conAdminTODO');
                Modal.getOrCreateInstance(conAdminTODO).hide();
                self.edit_mode(false);
            }).catch ((error) => {
              console.log(error);
                notyf.error("Sorry something went wrong ", error);
            });


    }

    self.close_todo = function(hide_modal){
        if(self.todo().assigned_to() !== self.rootvm.user_logged_in()){
            if(!confirm('You are trying to close an issue that is not your own. Please confirm that you wish to close this issue.')){
                return false;
            };
        }
        let to_close = self.todo();
        const data = {
            todo_uuid : self.todo().todo_uuid(),
            close_comment: self.todo().close_comment(),
            close_action: self.todo().close_action()
        };
        const options = {
            method: 'POST',
            body: ko.toJSON( data )
        };
        fetch( '/api/admin/todo/close', options )
            .then( response =>
            {
                if(!response.ok){
                    console.log(response);
                    throw new Error("Something went wrong!");
                }
                else{
                  const contentType = response.headers.get("content-type");
                  if(contentType && contentType.indexOf("application/json") === -1){
                    throw new Error("Response was not JSON");
                  }

                  return response.json()
                }
            }
            )
            .then( response => {
                // Do something with response.
                //self.sc_event().todo_list.push(new SCAdminTodo(response.todo));
                //
                to_close.effective_upper(response.todo.effective.upper);
                notyf.success('Todo closed.');
                if(hide_modal !== false){
                    const conAdminTODO = document.getElementById('conAdminTODO');
                    Modal.getOrCreateInstance(conAdminTODO).hide();
                }
            } )
            .catch((error) => {
              console.log(error);
                notyf.error("Sorry something went wrong ", error);
            });
    }

    self.lookup_all_users = async () => {
        const response = await fetch ('/api/admin/all-admin-users', {credentials:'same-origin'});
        const result = await response.json()
        if (result.success === true) {
            return result.users;
        }
        return []
    }

    self.lookup_all_todo_types = async () => {
        const response = await fetch ('/api/admin/all-admin-todo-types', {credentials:'same-origin'});
        const result = await response.json()
        if (result.success === true) {
            return result.todo_types;
        }
        return []
    }

    self.initialize = async () => {

        console.info("INITING TODO VM");
        self.lookup_all_users().then(users =>{
            self.admin_user_list(users);
        });

        self.lookup_all_todo_types().then(todo_types=>{
            self.admin_todo_type_list(todo_types);
        });

        return

    }
}
